module.exports = function() {
  return new Worker(__webpack_public_path__ + "199171de62947b54c6df.worker.js");
};


// WEBPACK FOOTER //
// src/models/LocalTelemetry.worker.js